import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Form from 'react-bootstrap/Form'
import Typography from '@material-ui/core/Typography'
import RoomIcon from '@material-ui/icons/Room'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap'
import Divider from '@material-ui/core/Divider'
import SearchIcon from '@material-ui/icons/Search'

import { TableFormats } from '../TableHelpers'
class MakeshiftDrawer extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    screenWidth: PropTypes.number,
    selectedPoints: PropTypes.array,
    addHighlight: PropTypes.func,
    genreDemoSummary: PropTypes.object
  }

  constructor (props){
    super(props)
    this.state = {
      highlightBox: false,
      projectionBox: false,
      projectionValue: 'Batwoman Projection',
      selectedPoints: [],
      searchKeyword: '',
      searchResult: [],
      topContent: []
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.selectedPoints !== this.props.selectedPoints) {
      let topContent = this.props.selectedPoints.filter(s => s.numAlignments > -1) // few numAlignments values are Other, skip that
      topContent = topContent.sort((a, b) => b.numAlignments - a.numAlignments)
      topContent = topContent.length > 5 ? topContent.slice(0, 5) : topContent
      this.setState({
        selectedPoints: this.props.selectedPoints,
        topContent: topContent
      })
    }

    if (prevState.searchKeyword !== this.state.searchKeyword && this.props.selectedPoints && this.state.searchKeyword.length > 1) {
      this.setState({ searchResult: this.props.selectedPoints.filter(e => e.name.toLowerCase().indexOf(this.state.searchKeyword.toLowerCase()) > -1) })
    }
  }

  toggleHighlight = () => {
    this.setState({
      highlightBox: !this.state.highlightBox
    })
  }

  toggleProjection = () => {
    this.setState({
      projectionBox: !this.state.projectionBox
    })
  }

  projectionOption = (event) => {
    this.setState({
      projectionValue: event.target.value
    })
  }

  handleChange = (event) => {
    this.setState({ searchKeyword: event.target.value })
  }

  render () {
    const highlightBox = this.state.highlightBox
    const genreDemoSummary = this.props.genreDemoSummary && this.props.genreDemoSummary.details
      return (
        <Box className="slideWrapper">
          <Box className="d-flex justify-content-center">
            { this.props.isOpen &&
            <Box className="w-50 d-flex align-items-center justify-content-center flex-column">
              <Dropdown isOpen={highlightBox} toggle={this.toggleHighlight} className="mb-2 d-flex align-items-center justify-content-center projectionBtn highlightBg highlightBtn">
                <DropdownToggle
                  tag="span"
                  data-toggle="dropdown"
                  aria-expanded={highlightBox}
                  >
                  <RoomIcon className="btnIcon" />
                </DropdownToggle>
                <DropdownMenu className="mt-1 highlightDropdown">
                  <Typography variant="h6" display="block" gutterBottom className="menuLabel">Add highlight</Typography>
                  <Box className="searchWrap d-flex align-items-center">
                    <Form.Group controlId="formBasicEmail">
                      <Form.Control type="text" placeholder="Media search" autoComplete="off"value={this.state.searchKeyword} onChange={(e) => this.handleChange(e)}/>
                    </Form.Group>
                    <SearchIcon />
                  </Box>
                  <Divider className="optionDivider"/>
                  <Box className="highlightOption">
                    <List>
                      {this.state.searchResult && this.state.searchResult.map((option, index) => {
                          return (
                            <ListItem className={option.showTooltip ? 'selectedEntity' : ''} key={index} onClick={() => this.props.addHighlight(option.id)}>
                              <Box className="d-flex align-items-center justify-content-between">
                                { !option.showTooltip && <Box className="optionAvatar" />}
                                { option.showTooltip && <AddCircleIcon style={{width: '18px', height: '18px', marginRight: '6px', fill: '#f5f7fa !important'}}/>}
                                <Typography variant="body2" gutterBottom>{option.name}</Typography>
                              </Box>
                              <Typography variant="body2" gutterBottom>{option.network}</Typography>
                            </ListItem>
                          )
                        })}
                    </List>
                  </Box>
                </DropdownMenu>
              </Dropdown>
              <Typography variant="caption" display="block" gutterBottom className="btnLabel">Add highlight</Typography>
            </Box>
            }
          </Box>
          <Box className="optionWrapper">
            <AudienceView genreDemoSummary={genreDemoSummary}/>
            <GenderView genreDemoSummary={genreDemoSummary}/>
            <AgeView genreDemoSummary={genreDemoSummary}/>
            <TopContentView topContent={this.state.topContent}/>
          </Box>
        </Box>
      )
  }
}

export const AudienceView = ({genreDemoSummary}) => {
  return (
    <Box>
      <Divider className="drawerDivider"/>
      <Box className="optionLabel d-flex align-items-center justify-content-between">
        <Typography variant="subtitle2" gutterBottom>Audience</Typography>
      </Box>
      <List>
        <ListItem>
          <Typography variant="body2" gutterBottom>Max Potential</Typography>
          <Typography variant="body2" gutterBottom className="optionInfo">{genreDemoSummary && TableFormats.trackerFormatKM(genreDemoSummary.num_users)}</Typography>
        </ListItem>
      </List>
    </Box>
  )
}

AudienceView.propTypes = {
  genreDemoSummary: PropTypes.object
}

export const GenderView = ({genreDemoSummary}) => {
  return (
    <Box>
      <Divider className="drawerDivider"/>
      <Box className="optionLabel d-flex align-items-center justify-content-between">
        <Typography variant="subtitle2" gutterBottom>Gender</Typography>
      </Box>
      <List>
        <ListItem>
          <Typography variant="body2" gutterBottom>Male</Typography>
          <Typography variant="body2" gutterBottom className="optionInfo">{genreDemoSummary && TableFormats.formatPercentage(genreDemoSummary.male_percentage)}</Typography>
        </ListItem>
        <ListItem>
          <Typography variant="body2" gutterBottom>Female</Typography>
          <Typography variant="body2" gutterBottom className="optionInfo">{genreDemoSummary && TableFormats.formatPercentage(genreDemoSummary.female_percentage)}</Typography>
        </ListItem>
      </List>
    </Box>
  )
}

GenderView.propTypes = {
  genreDemoSummary: PropTypes.object
}

export const AgeView = ({genreDemoSummary}) => {
  return (
    <Box>
      <Divider className="drawerDivider"/>
      <Box className="optionLabel d-flex align-items-center justify-content-between">
        <Typography variant="subtitle2" gutterBottom>Age</Typography>
      </Box>
      <List>
        <ListItem>
          <Typography variant="body2" gutterBottom>&lt;18</Typography>
          <Typography variant="body2" gutterBottom className="optionInfo">{genreDemoSummary && TableFormats.formatPercentage(genreDemoSummary.age_under18_percentage)}</Typography>
        </ListItem>
        <ListItem>
          <Typography variant="body2" gutterBottom>18-24</Typography>
          <Typography variant="body2" gutterBottom className="optionInfo">{genreDemoSummary && TableFormats.formatPercentage(genreDemoSummary.age18_to24_percentage)}</Typography>
        </ListItem>
        <ListItem>
          <Typography variant="body2" gutterBottom>25-34</Typography>
          <Typography variant="body2" gutterBottom className="optionInfo">{genreDemoSummary && TableFormats.formatPercentage(genreDemoSummary.age25_to34_percentage)}</Typography>
        </ListItem>
        <ListItem>
          <Typography variant="body2" gutterBottom>35-54</Typography>
          <Typography variant="body2" gutterBottom className="optionInfo">{genreDemoSummary && TableFormats.formatPercentage(genreDemoSummary.age35_to54_percentage)}</Typography>
        </ListItem>
        <ListItem>
          <Typography variant="body2" gutterBottom>+55</Typography>
          <Typography variant="body2" gutterBottom className="optionInfo">{genreDemoSummary && TableFormats.formatPercentage(genreDemoSummary.age55_plus_percentage)}</Typography>
        </ListItem>
      </List>
    </Box>
  )
}

AgeView.propTypes = {
  genreDemoSummary: PropTypes.object
}

export const TopContentView = ({topContent}) => {
  return (
    <Box>
      <Divider className="drawerDivider"/>
      <Box className="optionLabel d-flex align-items-center justify-content-between">
        <Typography variant="subtitle2" gutterBottom>Top Content</Typography>
      </Box>
      <List>
        {topContent && topContent.map((option, index) => {
          return (
            <ListItem key={index}>
              <Typography variant="body2" gutterBottom>{option.name}</Typography>
              <Typography variant="body2" gutterBottom className="optionInfo">{option.network}</Typography>
            </ListItem>
          )
        })}
      </List>
    </Box>
  )
}

TopContentView.propTypes = {
  topContent: PropTypes.array
}

export default MakeshiftDrawer
